import React from "react";
import PropTypes from "prop-types";

/**
 * 鉴权表单（No Auth / Bearer Token / Basic Auth 三种）
 */
function AuthForm({ authType, authToken, authUser, authPwd, isEdit = true, onChange }) {
  return (
    <div style={{ maxWidth: "500px" }}>
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <label
          style={{ fontSize: "14px", color: "#475569", fontWeight: 600 }}
        >
          Type
        </label>
        <select
          className="tfe-form-control"
          style={{ width: "200px" }}
          value={authType}
          disabled={!isEdit}
          onChange={(e) => onChange("authType", e.target.value)}
        >
          <option value="none">No Auth</option>
          <option value="bearer">Bearer Token</option>
          <option value="basic">Basic Auth</option>
        </select>
      </div>
      {authType === "none" && (
        <div className="tfe-empty-placeholder">此请求未使用任何鉴权 (No Auth)。</div>
      )}
      {authType === "bearer" && (
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <label
            style={{ fontSize: "14px", color: "#475569", fontWeight: 600 }}
          >
            Token
          </label>
          <input
            className="tfe-form-control"
            value={authToken ?? ""}
            readOnly={!isEdit}
            onChange={(e) => onChange("authToken", e.target.value)}
            placeholder="键入 '/' 键快速插入变量"
          />
        </div>
      )}
      {authType === "basic" && (
        <div style={{ display: "flex", gap: "16px", flexDirection: "column" }}>
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <label
              style={{
                width: "80px",
                fontSize: "14px",
                color: "#475569",
                fontWeight: 600,
              }}
            >
              Username
            </label>
            <input
              className="tfe-form-control"
              value={authUser ?? ""}
              readOnly={!isEdit}
              onChange={(e) => onChange("authUser", e.target.value)}
            />
          </div>
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <label
              style={{
                width: "80px",
                fontSize: "14px",
                color: "#475569",
                fontWeight: 600,
              }}
            >
              Password
            </label>
            <input
              type="password"
              className="tfe-form-control"
              value={authPwd ?? ""}
              readOnly={!isEdit}
              onChange={(e) => onChange("authPwd", e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

AuthForm.propTypes = {
  authType: PropTypes.oneOf(["none", "bearer", "basic"]),
  authToken: PropTypes.string,
  authUser: PropTypes.string,
  authPwd: PropTypes.string,
  /** 是否允许编辑（true=可切换鉴权类型与输入 Token/用户名/密码；false=只读查看，控件禁用）。默认 true。 */
  isEdit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default AuthForm;
